// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loader-overlay{position:fixed;width:100%;height:100%;top:0;left:0;right:0;bottom:0;background:hsla(0,0%,100%,.9) url(https://cdn.solfacil.com.br/assets/img/loading-for-legacy.gif) no-repeat 50%;z-index:99999}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
